import { BaseUserToken } from '../../common';

export class SimpleUserToken extends BaseUserToken {
    constructor(public user) {
        super();
    }
}
